import React, { useEffect } from "react";
import Slider from "react-slick";
import WOW from "wowjs";
import { FaStar } from "react-icons/fa";
import "animate.css/animate.min.css";

const Testimonials = () => {
  useEffect(() => {
    // Initialize WOW.js when component mounts
    new WOW.WOW({ live: false }).init();
  }, []);

  const settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
  };

  return (
    // <section className="boxcar-testimonial-section home1">
    //   <div className="boxcar-container">
    //     <div className="wow fadeInUp boxcar-title " data-wow-delay="0.1s">
    //       <h2>What our customers say</h2>
    //       <div className="text">
    //         Rated 4.7 / 5 based on 28,370 reviews — Showing our 4 & 5 star reviews
    //       </div>
    //     </div>

    //     <Slider {...settings} className="testimonial-slider-two">
    //       {/* Slide 1 */}
    //       <div className="testimonial-slide-two">
    //         <div className="row">
    //           <div className="image-column col-lg-4 col-md-12 col-sm-12">
    //             <div className="inner-column wow fadeInUp" data-wow-delay="0.1s">
    //               <div className="image-box">
    //                 <figure className="image">
    //                   <img src="images/resource/test-1.jpg" alt="testimonial" />
    //                 </figure>
    //               </div>
    //             </div>
    //           </div>

    //           <div className="content-column col-lg-8 col-md-12 col-sm-12">
    //             <div className="inner-column wow fadeInUp" data-wow-delay="0.2s">
    //               <ul className="rating">
    //                 {[1, 2, 3, 4, 5].map((n) => (
    //                   <li key={n}>
    //                     <FaStar />
    //                   </li>
    //                 ))}
    //                 <li>
    //                   <span>4.8</span>
    //                 </li>
    //               </ul>
    //               <h6 className="title">Ali TUFAN</h6>
    //               <span>Designer</span>
    //               <div className="text">
    //                 I'd suggest Macklin Motors Nissan Glasgow South to a friend because
    //                 I had great service from my salesman Patrick and all of the team.
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>

    //       {/* Slide 2 */}
    //       <div className="testimonial-slide-two">
    //         <div className="row">
    //           <div className="image-column col-lg-4 col-md-12 col-sm-12">
    //             <div className="inner-column wow fadeInUp" data-wow-delay="0.1s">
    //               <div className="image-box">
    //                 <figure className="image">
    //                   <img src="images/resource/test-1.jpg" alt="testimonial" />
    //                 </figure>
    //               </div>
    //             </div>
    //           </div>

    //           <div className="content-column col-lg-8 col-md-12 col-sm-12">
    //             <div className="inner-column wow fadeInUp" data-wow-delay="0.2s">
    //               <ul className="rating">
    //                 {[1, 2, 3, 4, 5].map((n) => (
    //                   <li key={n}>
    //                     <FaStar />
    //                   </li>
    //                 ))}
    //                 <li>
    //                   <span>4.8</span>
    //                 </li>
    //               </ul>
    //               <h6 className="title">John Smith</h6>
    //               <span>Developer</span>
    //               <div className="text">
    //                 Excellent car buying experience. Smooth process and friendly staff!
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </Slider>
    //   </div>
    // </section>
    <>
    <section className="about-inner-one layout-radius">
    {/* boxcar-testimonial-section-four */}
        <div style={{padding:"0px"}} className="boxcar-testimonial-section-four v1 pt-0">
          <div className="large-container">
            <div style={{padding:"30px"}} className="right-box">
              <div className="boxcar-title">
                <h2>What our customers say</h2>
                {/* <div className="text">
                  Rated 4.7 / 5 based on 28,370 reviews Showing our 4 &amp; 5
                  star reviews
                </div> */}
              </div>
              <div className="row stories-slider">
                {/* testimonial-block-four */}
                <div className="testimonial-block-four col-lg-4 col-md-6 col-sm-12">
                  <div className="inner-box">
                    <figure className="icon">
                      <a href="#">
                        <img src="images/resource/comas.png"   />
                      </a>
                    </figure>
                    <h6 className="title">Great Experience</h6>
                    <div className="text">
                      {" "}
                      “Buying a car from Car Junction was smooth and stress-free. The listings were clear, pricing was transparent, and the overall experience exceeded my expectations.”
                    </div>
                    <div className="auther-info">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/test-auther-1.jpg"   />
                        </a>
                      </figure>
                      <h6 className="name">Leslie Alexander</h6>
                      <span>Verified Customer</span>
                    </div>
                  </div>
                </div>
                {/* testimonial-block-four */}
                <div className="testimonial-block-four col-lg-4 col-md-6 col-sm-12">
                  <div className="inner-box">
                    <figure className="icon">
                      <a href="#">
                        <img src="images/resource/comas.png"   />
                      </a>
                    </figure>
                    <h6 className="title">Awesome Platform</h6>
                    <div className="text">
                      {" "}
                      “Car Junction made it really easy to find the right car. The website is user-friendly, cars are well-described, and the support team was very responsive.”
                    </div>
                    <div className="auther-info">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/test-auther-2.jpg"   />
                        </a>
                      </figure>
                      <h6 className="name">Floyd Miles</h6>
                      <span>Verified Customer</span>
                    </div>
                  </div>
                </div>
                {/* testimonial-block-four */}
                <div className="testimonial-block-four col-lg-4 col-md-6 col-sm-12">
                  <div className="inner-box">
                    <figure className="icon">
                      <a href="#">
                        <img src="images/resource/comas.png"   />
                      </a>
                    </figure>
                    <h6 className="title">Perfect Quality</h6>
                    <div className="text">
                      {" "}
                      “Amazing design, easy to customize and a design quality
                      superlative account on its cloud platform for the
                      optimized performance. And we didn’t on our original
                      designs.”
                    </div>
                    <div className="auther-info">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/test-auther-3.jpg"   />
                        </a>
                      </figure>
                      <h6 className="name">Dianne Russell</h6>
                      <span>Verified Customer</span>
                    </div>
                  </div>
                </div>
                {/* testimonial-block-four */}
                <div className="testimonial-block-four col-lg-4 col-md-6 col-sm-12">
                  <div className="inner-box">
                    <figure className="icon">
                      <a href="#">
                        <img src="images/resource/comas.png"   />
                      </a>
                    </figure>
                    <h6 className="title">Highly Recommended</h6>
                    <div className="text">
                      {" "}
                      “Car Junction offers a wide range of cars and honest pricing. It’s one of the most reliable platforms for buying a car.”
                    </div>
                    <div className="auther-info">
                      <figure className="image">
                        <a href="#">
                          <img  style={{height:"60px", width:"60px"}} src="images/resource/candidate-4.png"   />
                        </a>
                      </figure>
                      <h6 className="name">Rahul Mehta</h6>
                      <span>Verified Customer</span>
                    </div>
                  </div>
                </div>
                {/* testimonial-block-four */}
                <div className="testimonial-block-four col-lg-4 col-md-6 col-sm-12">
                  <div className="inner-box">
                    <figure className="icon">
                      <a href="#">
                        <img src="images/resource/comas.png"   />
                      </a>
                    </figure>
                    <h6 className="title">Excellent Service</h6>
                    <div className="text">
                      {" "}
                     “From browsing to final purchase, Car Junction delivered a seamless experience. I would definitely buy from them again.”
                    </div>
                    <div className="auther-info">
                      <figure className="image">
                        <a href="#">
                          <img style={{height:"60px", width:"60px"}} src="images/resource/candidate-2.png"   />
                        </a>
                      </figure>
                      <h6 className="name">Garvit Manchanda</h6>
                      <span>Happy Buyer</span>
                    </div>
                  </div>
                </div>
                {/* testimonial-block-four */}
                <div className="testimonial-block-four col-lg-4 col-md-6 col-sm-12">
                  <div className="inner-box">
                    <figure className="icon">
                      <a href="#">
                        <img src="images/resource/comas.png"   />
                      </a>
                    </figure>
                    <h6 className="title">Smooth Process</h6>
                    <div className="text">
                      {" "}
                      “I appreciated how straightforward the entire experience was. No hidden charges and excellent customer support throughout.”
                    </div>
                    <div className="auther-info">
                      <figure className="image">
                        <a href="#">
                          <img  style={{height:"60px", width:"60px"}} src="images/resource/candidate-1.png"   />
                        </a>
                      </figure>
                      <h6 className="name">Ronald Richards</h6>
                      <span>Satisfied Customer</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </section>
        {/* End boxcar-testimonial-section-four */}
    </>
  );
};

export default Testimonials;
